import { API } from '@config';
import { ResidentialServiceTable } from '@types';


export const getResidentialServiceTableData = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/start-stop-move-service-residential-tables`, options);
  const data: ResidentialServiceTable = await response.json();

  return data;
};
